// @flow

import { combineReducers } from 'redux';
import auth from './auth';
import modules from './modules';
import mapData from './mapData';
import photos from './photos';
import model from './model';
import resource from './resource';
import flightManager from './flightManager';
import upload from './upload';
import video from './video';
import faults from './faults';
import comments from './comments';
import domainProperties from './domainProperties';

export default combineReducers({
  auth,
  modules,
  mapData,
  photos,
  model,
  resource,
  flightManager,
  upload,
  video,
  faults,
  comments,
  domainProperties
});



// WEBPACK FOOTER //
// ./src/reducers/RootReducer.jsx